import React from 'react';
import agent from '../../agent';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import AnyInput from '../GenericInput/AnyInput';
import GenericInput from '../GenericInput';
import { APPLICATION_PAGE_LOADED, APPLICATION_PAGE_UNLOADED, APPLICATION_SUBMITTED, SITE_SUBMITTED } from '../../constants/actionTypes';
const Promise = global.Promise;

const mapStateToProps = state => ({
  templates: state.templates,
});

const mapDispatchToProps = dispatch => ({
  onLoad: payload =>
    dispatch({ type: APPLICATION_PAGE_LOADED, payload }),
  onUnload: () =>
    dispatch({ type: APPLICATION_PAGE_UNLOADED }),
  submitSite: payload =>
    dispatch({ type: SITE_SUBMITTED, payload }),
});

class NewSite extends React.Component {
  constructor() {
    super();

    this.state = { 
      isNameGood: false,
      siteData: {
        id: '',
        template: '',
        bridePhoto: '/files/bride.jpeg',
        engagementMapLocation: '',
        weddingLocation: '',
        weddingDatetime: new Date(),
        engagementDatetime: new Date(),
        couplePhoto: '/files/flower.png',
        groom: '',
        bride: '',
        groomPhoto: '/files/groom.jpeg',
        weddingMapLocation: '',
        engagementLocation: '',
        colorOverride: 'f44482'
      },
      columns: []
    };

    this.updateStateFromEvent = field => ev => {
      const state = this.state;
      const siteData = state.siteData;
      const newSiteData = Object.assign({}, siteData, { [field]: ev.target.value });
      const newState = Object.assign({}, state, {siteData: newSiteData});
      this.setState(newState);
    };
    
    this.updateStateWithValue = (field, value) => {
      const state = this.state;
      const siteData = state.siteData;
      const newSiteData = Object.assign({}, siteData, { [field]: value });
      const newState = Object.assign({}, state, {siteData: newSiteData});
      console.log(state.siteData, newState.siteData)
      this.setState(newState);
    };

    this.changeSiteFields = templateName => {
      this.props.templates.forEach(template => {
        if(templateName === template.name) {
          const state = this.state;
          const newState = Object.assign({}, state, template.columns);
          this.setState(newState);
        }
      })
    }

    this.updateSiteState = (fieldValueObj) => {
      const state = this.state;
      const siteData = { ...state.siteData, ...fieldValueObj};
      const newState = Object.assign({}, state, {siteData});
      console.log('updating site state', fieldValueObj, newState);
      this.setState(newState);
    };

    this.checkAvailability = () => {
      console.log('POST ', this.state.siteData.template, this.state.siteData.id);
      if(!this.state.siteData.template) {
        const state = this.state;
        const siteData = state.siteData;
        const newSiteData = Object.assign({}, siteData, { template: this.props.templates[0].name });
        const newState = Object.assign({}, state, {siteData: newSiteData});
        this.setState(newState);
      }
      if(!this.state.siteData.id) {
        alert('Please give a name for site');
      }else {
        // console.log(agent.Sites.checkAvailability(this.state.siteData.id, this.state.siteData.template));
        agent.Sites.checkAvailability(this.state.siteData.id, this.state.siteData.template)
          .then(result => {
            if(result.message == 'ok') {
              const state = this.state;
              let columns = [];
              this.props.templates.forEach(template => {
                if(this.state.siteData.template === template.name) {
                  columns =  template.columns;
                }
              })
              const newState = Object.assign({}, state, {isNameGood: true, columns});
              this.setState(newState);
            }else {
              alert(result.message);
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    }

    this.submitForm = ev => {
      ev.preventDefault();
      console.log(this.state.siteData);
      const siteRequest = Object.assign({}, this.state.siteData);
      // let agentPromise = agent.Sites.createSite(siteRequest);
      this.props.submitSite(agent.Sites.createSite(siteRequest));
    };
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.templates && props.templates.length > 0 && (!state.siteData.template)) {
      const siteData = state.siteData;
      const newSiteData = Object.assign({}, siteData, { template: props.templates[0].name });
      const newState = Object.assign({}, state, {siteData: newSiteData});
      return newState;
    }
    return null;
  }

  render() {
    return (
      <div className="container">
        <h2>Create Site</h2>
        <br/>
        <div>
          {!this.state.isNameGood && 
            <React.Fragment>
              <div className="form-group">
                <label htmlFor="Id">Please enter a name for site <br/>
                (Eg - If you enter MaheshPriyaka here, site will be available as dearinvite.com/sites/<b>maheshpriyanka</b>)</label>
                <input type="text" className="form-control" name="Name" id="Id" 
                  value={this.state.FirstName} 
                  onChange={this.updateStateFromEvent('id')}></input>
              </div>
              <div className="form-group">
                <label htmlFor="template">Please select a template</label>
                <select value={this.state.siteData.template} id="template" onChange={this.updateStateFromEvent('template')}>
                  {this.props.templates.map((template) => <option key={template.name} value={template.name}>{template.name}</option> )}
                </select>
              </div>
              <button className="btn btn-primary" onClick={this.checkAvailability}>
                Check Site Availability and Start
              </button>
              <Link to={'/sites'} className="btn">Cancel</Link>
            </React.Fragment>
          }

          {/* {this.props.templates.map((template) => <option value={template.name}>{template.name}</option> )} */}

          {/* <div className="form-group">
            <label htmlFor="FirstName">First Name</label>
            <input type="text" className="form-control" name="FirstName" id="FirstName" 
              value={this.state.FirstName} 
              onChange={this.updateStateFromEvent('FirstName')}></input>
          </div> */}
          {this.state.isNameGood && 
            <React.Fragment>
              {this.state.columns.map((column, i) => 
                <AnyInput key={column.name} 
                  column={column} 
                  onChange={this.updateSiteState} 
                  value={this.state.siteData[column.name]}/>
                  
                )}
              <button className="btn btn-primary" onClick={this.submitForm}>
                Submit
              </button>
              <Link to={'/sites'} className="btn">Cancel</Link>
            </React.Fragment>
          }
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewSite);
